import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated'); // Überprüfe, ob der Benutzer eingeloggt ist
  return isAuthenticated ? children : <Navigate to="/login" />; // Weiterleitung zur Login-Seite, wenn nicht eingeloggt
};

export default PrivateRoute;
